import React from 'react';
import Image from 'next/image';

interface ILogoCloudbar {}

export const LogoCloudbar: React.FC<ILogoCloudbar> = () => {
    return (
        <figure className="relative flex w-max flex-row gap-0">
            <Image
                src="/assets/logos/cgLogo.png"
                className="relative -top-1 left-1 w-10"
                alt="Logo"
                width={40}
                height={40}
                loading="lazy"
            />
            <div className="flex flex-col">
                <button className="text-2xl font-medium text-neutral-100">cloudbar</button>
                <div className="gradient-cb3-cymk block h-[2px] w-full" />
            </div>
        </figure>
    );
};
